module.exports = __webpack_public_path__ + "static/media/lease1_img4.2728e1bc.jpg";